import React from 'react';
import { connect } from 'react-redux';

import { resetPassword } from '../../../../redux/auth/passwordReset/actions';

import PasswordResetModal from './PasswordResetModal';

import * as selectors from './selectors';

const PasswordResetModalConnected = (props) => <PasswordResetModal {...props} />;

const mapDispatchToProps = (state) => ({
  isLoading: selectors.selectIsLoading(state),
  error: selectors.selectError(state),
  errorMessage: selectors.selectErrorMessage(state),
});

const mapActionsToProps = {
  resetPassword,
};

export default connect(mapDispatchToProps, mapActionsToProps)(PasswordResetModalConnected);
